// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3AKsB","colMaxWidth":"Table_colMaxWidth__2UwpZ"};